/* unplugin-vue-components disabled */import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "rirht_captions_area"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "row"
};
const _hoisted_5 = {
  class: "row"
};
const _hoisted_6 = {
  key: 1,
  class: "right_captions_area"
};
const _hoisted_7 = {
  key: 0,
  class: "right_captions_area_list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 2,
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_10 = {
  key: 3,
  style: {
    "width": "100%",
    "height": "100%"
  }
};
import VideoCard from "@/components/Card/VideoCard/index.vue";
import Player from "@/components/jessibuca/index.vue";
import XiGuaPlayer from "@/components/XGPlayer/xgPlayer.vue";
import TextCard from "@/components/Card/TextCard/index.vue";
import screenfull from "screenfull";
import usePermissionStore from "@/store/modules/permission";
export default {
  __name: 'car',
  props: {
    weatherData: {
      type: Object,
      default: {}
    },
    // 是否显示提示
    isTasking: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const permission = usePermissionStore();
    const {
      proxy
    } = getCurrentInstance();
    const pageData = inject("pageData");
    const handleChildEventTimeBack = inject("handleChildEventTimeBack");
    const switchVideo = inject("switchVideo");
    const props = __props;
    const showSubtitle = ref(true);
    const fullscreen = ref(false);
    const videoStartRecord = ref(false);
    const aspectRatioState = ref(false);
    const downloadProgressFormat = percentage => {
      return percentage === 100 ? '已完成' : `下载中`;
    };
    function onCarVideoCardSwitchChange() {
      showSubtitle.value = !showSubtitle.value;
    }
    function downloadMp4(a, b) {
      emit("downloadMp4", a, b);
    }
    function onCarVideoCardFullScreenClick() {
      if (proxy.$refs["carVideoRef"] === undefined) {
        return;
      }
      setTimeout(() => {
        requestAnimationFrame(() => {
          const dom = document.getElementsByClassName("car_video_card")[0];
          if (fullscreen.value) {
            screenfull.exit();
            fullscreen.value = false;
            proxy.$refs["carVideoRef"].setJessibucaStyle(false);
          } else {
            screenfull.request(dom);
            fullscreen.value = true;
            proxy.$refs["carVideoRef"].setJessibucaStyle(true);
          }
        });
      }, 50);
    }
    function onCarVideoCardVideoClick() {
      if (proxy.$refs["carVideoRef"] === undefined) {
        return;
      }
      if (videoStartRecord.value) {
        proxy.$refs["carVideoRef"].videoStopRecordAndSave();
        videoStartRecord.value = false;
      } else {
        proxy.$refs["carVideoRef"].videoStartRecord();
        videoStartRecord.value = true;
        proxy.$modal.msgWarning("开始录屏，再次点击结束录屏");
      }
    }
    function onCarVideoCardScreenCutClick() {
      if (proxy.$refs["carVideoRef"] === undefined) {
        return;
      }
      proxy.$refs["carVideoRef"].videoScreenShot();
    }
    function onCarVideoCardReduction() {
      if (proxy.$refs["carVideoRef"] === undefined) {
        return;
      }
      aspectRatioState.value = !aspectRatioState.value;
      proxy.$refs["carVideoRef"].setJessibucaStyle(aspectRatioState.value);
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createBlock(VideoCard, {
        ref: "carVideoCardRef",
        "show-subtitle": _unref(showSubtitle),
        "show-switch": __props.isTasking,
        "show-full-screen": __props.isTasking,
        "show-video-camera": __props.isTasking,
        "show-picture-outlined": __props.isTasking,
        "show-aspect-ratio": __props.isTasking,
        "controlel-size": "small",
        "aspect-ratio-state": _unref(aspectRatioState),
        onSwitchChange: onCarVideoCardSwitchChange,
        onFullScreenClick: onCarVideoCardFullScreenClick,
        onVideoClick: onCarVideoCardVideoClick,
        onScreenCutClick: onCarVideoCardScreenCutClick,
        onReduction: onCarVideoCardReduction,
        class: "car_video_card"
      }, {
        default: _withCtx(() => [_unref(showSubtitle) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, "风向: " + _toDisplayString(__props.weatherData.infos.win), 1), _createElementVNode("div", _hoisted_3, "风速: " + _toDisplayString(__props.weatherData.infos.win_meter), 1), _createElementVNode("div", _hoisted_4, "降雨量: " + _toDisplayString(__props.weatherData.infos.rain_pcpn), 1), _createElementVNode("div", _hoisted_5, "实时温度: " + _toDisplayString(__props.weatherData.infos.tem), 1)])) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "box-name"
        }, null, -1)), _unref(pageData).recordVideo.taskCarList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = $event => _unref(pageData).recordListShow.four = !_unref(pageData).recordListShow.four),
          class: "row"
        }, [_createVNode(_component_el_button, {
          style: {
            "width": "10.1rem"
          },
          size: "small"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("录像列表", -1)]))]),
          _: 1
        })]), _unref(pageData).recordListShow.four ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).recordVideo.taskCarList, (info, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            onClick: $event => _unref(switchVideo)(index, 3),
            class: "row"
          }, [info.liveRecordStartTime === _unref(pageData).recordVideo.taskCarIndex ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(info.liveRecordStartTime) + "—" + _toDisplayString(info.liveRecordStopTime), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            size: "small",
            type: "info"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(info.liveRecordStartTime) + "—" + _toDisplayString(info.liveRecordStopTime), 1)]),
            _: 2
          }, 1024))], 8, _hoisted_8);
        }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(pageData).deviceVideo.taskCarUrl !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(Player, {
          ref: "carVideoRef",
          url: _unref(pageData).deviceVideo.taskCarUrl,
          "flv-url": _unref(pageData).deviceVideo.taskCarFlvUrl,
          fluent: "",
          autoplay: ""
        }, null, 8, ["url", "flv-url"])])) : _createCommentVNode("", true), _unref(pageData).recordVideo.taskCarUrl !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(XiGuaPlayer, {
          onReportedTime: _unref(handleChildEventTimeBack),
          id: 'app3',
          "video-index": _unref(pageData).recordVideo.taskCarId,
          "video-url": _unref(pageData).recordVideo.taskCarUrl,
          "start-time": _unref(pageData).recordVideo.taskCarPlayTime
        }, null, 8, ["onReportedTime", "video-index", "video-url", "start-time"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show-subtitle", "show-switch", "show-full-screen", "show-video-camera", "show-picture-outlined", "show-aspect-ratio", "aspect-ratio-state"]);
    };
  }
};